module.exports = (context) => ({
    signup: require('./signup')(context),
    communication: require('./communication')(context),
    errorHandling: require('./error-handling')(context),
    auth: require('./auth')(context)
});
